import { useState, useEffect } from "react";
import { useAuth, API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import {
  Search,
  Plus,
  Edit,
  Trash2,
  Package,
  Filter,
  Warehouse,
  MapPin,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";



// const CATEGORIES = [
//   { value: "all", label: "Todas las Categorías", color: "bg-slate-100 text-slate-700" },
//   { value: "gomas", label: "Gomas", color: "bg-blue-100 text-blue-700" },
//   { value: "baterias", label: "Baterías", color: "bg-amber-100 text-amber-700" },
//   { value: "aceites", label: "Aceites", color: "bg-emerald-100 text-emerald-700" },
//   { value: "accesorios", label: "Accesorios", color: "bg-purple-100 text-purple-700" },
// ];





const ArticlesPage = () => {
  const { token } = useAuth();
  const [WAREHOUSES, setWAREHOUSES] = useState([])
  const [CATEGORIES, setCATEGORIES] = useState([])

  const [articles, setArticles] = useState({
    rows: [],
    page: 1,
    totalRow: 0,
    totalPages: 0
  });
  const [loading, setLoading] = useState(true);
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [editingArticle, setEditingArticle] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [articleToDelete, setArticleToDelete] = useState(null);

  const [formData, setFormData] = useState({
    code: "",
    name: "",
    description: "",
    category: "gomas",
    brand: "",
    price: 0,
    price_wholesale: 0,
    price_fleet: 0,
    stock: 0,
  });
  const [saving, setSaving] = useState(false);

  //Terminos de Consultas
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentSucursal, setCurrentSucursal] = useState(-1);
  const [currentEstado, setCurrentEstado] = useState(1);


  useEffect(() => {
    fetchArticle()
    fetInicial();
  }, []);

  const fetInicial = async () => {
    try {


      const responsewh = await axios.get(`${API}/articles/warehouses`, { headers: { Authorization: `Bearer ${token}` } });
      setWAREHOUSES(responsewh.data)


      const responsecat = await axios.get(`${API}/articles/categories`, { headers: { Authorization: `Bearer ${token}` } });
      setCATEGORIES(responsecat.data)

    } catch (error) {
      toast.error("Error al cargar artículos");
    } finally {
      setLoading(false);
    }
  };

  const searchTermfilter = searchTerm.trim();

  const fetchArticle = async () => {
    try {

      const response = await axios.get(`${API}/articles`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          search: searchTermfilter,
          page: currentPage,
          cantidadRow: rowsPerPage,
          sucursal: currentSucursal,
          estado: currentEstado
        }
      });
      setArticles(response.data);
    } catch (error) {
      console.log(error)
      toast.error("Error al cargar Articulos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticle();
    //eslint-disable-next-line
  }, [searchTermfilter, rowsPerPage, currentPage, currentSucursal, currentEstado]);


  const getCategoryStyle = (category) => {
    const cat = CATEGORIES.find(c => c.value === category);
    return cat ? cat?.colors : "bg-slate-100 text-slate-700";
  };
  const getCategoryLabel = (category) => {
    const cat = CATEGORIES.find(c => c.value === category);
    return cat ? cat.label : category;
  };

  const openEditModal = (article) => {
    setEditingArticle(article);
    setFormData({
      code: article.code,
      name: article.name,
      description: article.description || "",
      category: article.category || "gomas",
      brand: article.brand || "",
      price: article.price,
      price_wholesale: article.price_wholesale || 0,
      price_fleet: article.price_fleet || 0,
      stock: article.stock,
    });
    setShowModal(true);
  };

  const resetForm = () => {
    setEditingArticle(null);
    setFormData({
      code: "",
      name: "",
      description: "",
      category: "gomas",
      brand: "",
      price: 0,
      price_wholesale: 0,
      price_fleet: 0,
      stock: 0,
    });
  };

  // const filteredArticles = articles.filter((article) => {
  //   const matchesSearch =
  //     article.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     article.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     article.brand?.toLowerCase().includes(searchTerm.toLowerCase());
  //   const matchesCategory = categoryFilter === "all" || article.category.trim() === categoryFilter.trim();
  //   return matchesSearch && matchesCategory;
  // });

  const formatCurrency = (amount) =>
    `RD$ ${amount?.toLocaleString("es-DO", { minimumFractionDigits: 2 })}`;

  // Count articles by category
  const categoryCounts = CATEGORIES.slice(1).map(cat => ({
    ...cat,
    count: articles.rows.filter(a => a.category === cat.value).length
  }));

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <h2 className="text-xl font-semibold text-slate-800">Catálogo de Artículos</h2>
          <p className="text-sm text-slate-500">{articles.rows.length} artículos registrados</p>
        </div>

      </div>


      {/* Category Filters */}
      <div className="flex flex-wrap gap-2 mb-4">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.value}
            data-testid={`filter-${cat.categoria}`}
            onClick={() => setCategoryFilter(cat.categoria)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${categoryFilter === cat.categoria

              ? "bg-slate-800 text-white"
              : " hover:opacity-80"

              }`}
          >
            {cat.description}
            {cat.categoria !== "all" && (
              <span className="ml-2 opacity-70">
                ({articles.rows.filter(c => c.category.trim() === cat.categoria.trim()).length || 0})
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="relative mb-6">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
        <Input
          data-testid="article-search"
          placeholder="Buscar por nombre, código o marca..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10 h-11"
        />
      </div>

      {/* Articles Table */}
      {articles.rows.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">
            <Package size={32} className="text-slate-400" />
          </div>
          <h3 className="text-lg font-medium text-slate-800 mb-2">
            No hay artículos
          </h3>
          <p className="text-slate-500 mb-4">
            {searchTerm || categoryFilter !== "all"
              ? "No se encontraron artículos con ese criterio"
              : "Comienza agregando tu primer artículo"}
          </p>
        </div>
      ) : (
        <div className="bg-white rounded border border-slate-200 overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-24">Código</TableHead>
                <TableHead>Artículo</TableHead>
                <TableHead className="w-28">Categoría</TableHead>
                <TableHead className="text-right">Consumo</TableHead>
                <TableHead className="text-right">Flotilla</TableHead>
                <TableHead className="text-right">Mayor</TableHead>
                <TableHead className="text-right w-20">Stock</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {articles.rows.map((article) => (
                <TableRow key={article.id} className="table-row-hover">
                  <TableCell className="font-medium mono text-sm">{article.code}</TableCell>
                  <TableCell>
                    <div>
                      <p className="font-medium text-slate-800">{article.name}</p>
                      {article.brand && (
                        <p className="text-xs text-slate-500">{article.brand}</p>
                      )}
                    </div>
                  </TableCell>
                  <TableCell>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCategoryStyle(article.category)}`}>
                      {getCategoryLabel(article.category)}
                    </span>
                  </TableCell>
                  <TableCell className="text-right mono text-blue-600">
                    {formatCurrency(article.price)}
                  </TableCell>
                  <TableCell className="text-right mono text-purple-600">
                    {article.price_fleet ? formatCurrency(article.price_fleet) : "-"}
                  </TableCell>
                  <TableCell className="text-right mono text-emerald-600">
                    {article.price_wholesale ? formatCurrency(article.price_wholesale) : "-"}
                  </TableCell>
                  <TableCell className="text-right">
                    <Popover>
                      <PopoverTrigger asChild>
                        <button
                          data-testid={`stock-btn-${article.id}`}
                          className={`px-2 py-1 rounded text-xs font-medium cursor-pointer hover:ring-2 hover:ring-offset-1 transition-all ${article.stock > 10
                            ? "bg-emerald-100 text-emerald-700 hover:ring-emerald-300"
                            : article.stock > 0
                              ? "bg-amber-100 text-amber-700 hover:ring-amber-300"
                              : "bg-red-100 text-red-700 hover:ring-red-300"
                            }`}
                        >
                          {article.stock}
                        </button>
                      </PopoverTrigger>
                      <PopoverContent className="w-72 p-0" align="end">
                        <div className="p-3 border-b border-slate-200 bg-slate-50">
                          <div className="flex items-center gap-2">
                            <Warehouse size={16} className="text-slate-500" />
                            <span className="font-semibold text-slate-800 text-sm">Existencia por Almacén</span>
                          </div>
                          <p className="text-xs text-slate-500 mt-1">{article.name}</p>
                        </div>
                        <div className="p-2">
                          {WAREHOUSES.map((wh) => {
                            const qty = article.stock_almacenes.filter(e => e.alm === wh.almacen)[0]?.existencia || 0
                            return (
                              <div
                                key={wh.key}
                                className="flex items-center justify-between py-1.5 px-2 hover:bg-slate-50 rounded text-sm"
                              >
                                <div className="flex items-center gap-2">
                                  <div className={`w-2 h-2 rounded-full ${wh.color}`}></div>
                                  <span className="text-slate-600 text-xs">{wh.description}</span>
                                </div>
                                <span className={`font-semibold mono text-xs ${qty > 5 ? "text-emerald-600" : qty > 0 ? "text-amber-600" : "text-red-500"
                                  }`}>
                                  {qty}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                        <div className="p-3 border-t border-slate-200 bg-slate-50 flex items-center justify-between">
                          <span className="text-sm font-medium text-slate-700">Total General:</span>
                          <span className="font-bold text-slate-800 mono">{article.stock}</span>
                        </div>
                      </PopoverContent>
                    </Popover>
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}




    </div>
  );
};

export default ArticlesPage;
